import PropTypes from 'prop-types';

const defaultProps = {
  email: null,
  website: null,
  linkedin: null,
  twitter: null,
};

const propTypes = {
  email: PropTypes.string,
  website: PropTypes.string,
  linkedin: PropTypes.string,
  twitter: PropTypes.string,
};

export {
  defaultProps as trainerSocialDefaultProps,
  propTypes as trainerSocialPropTypes,
};
